import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useState, useEffect } from 'react'

export function useAuthStatus() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);

    useEffect(()=>{
        const auth = getAuth()
        return onAuthStateChanged(auth, async (user)=>{
            if(user){
                // Refresh from the server so a verification completed elsewhere
                // (e.g. clicking the email link) is reflected here, not the stale
                // cached token. Only while UNverified: a reload counts as an
                // auth change, so Firestore drops and reopens every live
                // listener (the 400 on .../Listen/channel in the console) —
                // on every protected page, for no gain once you're verified.
                if (!user.emailVerified) {
                  try { await user.reload(); } catch { /* offline — use cached */ }
                }
                setLoggedIn(true);
                setEmailVerified(!!auth.currentUser?.emailVerified);
            } else {
                setLoggedIn(false);
                setEmailVerified(false);
            }
            setCheckingStatus(false);
        })

    }, []);


  return{loggedIn, emailVerified, checkingStatus};
}
